import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    render({ variant }) {
        return (
            <today-user-nav variant={variant}>
                <nav variant={variant}>
                    {this.renderLinks()}
                </nav>
            </today-user-nav>
        );
    }

    /* eslint-disable complexity */
    renderLinks = () => {
        let everyone_link_active = false;
        let everyone_link = this.props.everyone_link || '#everyone';
        let you_link = this.props.you_link || '#you';

        if (this.props.variant == 'number') {
            return this.renderLink('you active', you_link, 'For You');
        } else if (/general/.test(document.location.pathname) || !this.props.logged_in) {
            everyone_link_active = true;
        } else if (this.props.variant == 'tarot' || this.props.variant == 'hexagram') {
            if (!this.props.route || this.props.route == 'everyone') {
                everyone_link_active = true;
            }
        }

        return [
            this.renderLink(
                `everyone ${everyone_link_active ? 'active' : ''}`,
                everyone_link,
                'For Everyone'
            ),
            this.renderLink(
                `you ${everyone_link_active ? '' : 'active'}`,
                you_link,
                'For You'
            ),
        ];
    }
    /* eslint-enable complexity */

    renderLink = (className, href, label) => {
        const variant = this.props.variant == 'water' || this.props.variant == 'air'
            ? 'horoscope'
            : this.props.variant;

        const category = 'Daily Page Tabs';
        const action = this.props.logged_in ? 'LI Impression' : 'LO Impression';
        const gaLabel = `${variant.charAt(0).toUpperCase() + variant.slice(1)}:${label}`;

        this.props.trackEvent([category, action, gaLabel]);

        return (
            <a class={className} href={href} data-label={label} onClick={this.trackClick}>{label}</a>
        );
    }

    trackClick = (e) => {
        const variant = this.props.variant == 'water' || this.props.variant == 'air'
            ? 'horoscope'
            : this.props.variant;

        const category = 'Daily Page Tabs';
        const action = this.props.logged_in ? 'LI Click' : 'LO Click';
        const label = `${variant.charAt(0).toUpperCase() + variant.slice(1)}:${e.target.dataset.label}`;

        this.props.trackEvent([category, action, label]);
    }
}

const mapStateToProps = (state) => ({
    route: state.route,
    logged_in: state.user && state.user.logged_in,
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/today-user-nav.js